import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=50512912&scoped=true&"
import script from "./complete.vue?vue&type=script&lang=js&"
export * from "./complete.vue?vue&type=script&lang=js&"
import style0 from "./complete.vue?vue&type=style&index=0&id=50512912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50512912",
  null
  
)

export default component.exports